import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `EntradaAlmacen/eliminarEntradaAlmacenSeleccion`, method: 'POST', body: values, token: token})
}